import React from 'react';

export const FlexCol = ({ className = '', children, onClick = () => {} }) => (
  <div className={`flex flex-col ${className}`} onClick={onClick}>
    {children}
  </div>
);
